import { render } from "./PodcastSection.vue?vue&type=template&id=70e9e6f8"
import script from "./PodcastSection.vue?vue&type=script&lang=js"
export * from "./PodcastSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__